import MenuItem, { IMenuItem } from './MenuItem';

type ReducedCartItem = {
  skuId: number;
  quantity: number;
}

interface ICartItem extends IMenuItem {
  max_quantity: number;
  sku_base_price: string;
  sku_tax_amount: number;
  low_availability: boolean;
  sale_tag_enabled: boolean;
  display_order: boolean;
  sold_out: boolean;
  premium: boolean;

  readonly isSelected?: boolean;
  readonly isSoldOut?: boolean;
  readonly isMultipleSelectionAllowed?: boolean;
  readonly hasLowAvailability?: boolean;
  readonly skuVolume?: number;
  readonly unitPrice?: number;
  readonly totalPrice?: number;
}

class CartItem extends MenuItem implements ICartItem {
  max_quantity: number;
  sku_base_price: string;
  sku_tax_amount: number;
  low_availability: boolean;
  sale_tag_enabled: boolean;
  display_order: boolean;
  sold_out: boolean;
  day_part: string;
  premium: boolean;

  constructor(attributes: ICartItem) {
    super(attributes);
    this.max_quantity = this.max_quantity || 0;
  }

  get isSelected(): boolean {
    return !!this.quantity;
  }

  // TODO: why is this value different from sold_out?
  get isSoldOut(): boolean {
    return this.max_quantity === 0;
  }

  /**
   * Returns true if this item can be selected multiple
   * times (i.e., it is allowed to have quantity > 1).
   */
  get isMultipleSelectionAllowed(): boolean {
    return this.isSnack || this.isPreparedMeal || this.isBundle
      || this.isBreakfast || this.isLunch;
  }

  get hasLowAvailability(): boolean {
    return this.low_availability;
  }

  get skuVolume(): number {
    return Number.parseFloat(this.sku.volume);
  }
}

export type { ICartItem, ReducedCartItem };
export default CartItem;
